import {debounce} from '@helpers/utils'

import type {IField} from './BaseFormField';
import {BaseFormField} from './BaseFormField';

export class FormRadioField extends BaseFormField implements IField {
  inputs: HTMLInputElement[] = [];

  onChange() {
    super.onChange();
    this.confirm();

    // FIXME: parentを・・・
    const [input] = this.inputs.filter((i) => {
      i.parentElement?.parentElement?.classList.remove('checked');
      return i.checked;
    });
    input.parentElement?.parentElement?.classList.add('checked');
  }

  didMount() {
    super.didMount();
    this.onChange = debounce(this.onChange.bind(this), 200);

    this.inputs = [
      ...(this.element?.querySelectorAll(
        'input[type="radio"]',
      ) as NodeListOf<HTMLInputElement>),
    ];
    this.inputs.map((i) => {
      i.addEventListener('change', this.onChange);
    });
  }

  didUnmount() {
    this.inputs.map((i) => {
      i.removeEventListener('change', this.onChange);
    });
  }

  set readonly(val: boolean) {
    this.inputs.map((i) => {
      i.readOnly = val;
    });
  }

  get name(): string {
    const [input] = this.inputs;
    return input?.getAttribute('name') || '';
  }

  get value(): string {
    const [input] = this.inputs.filter((i) => {
      return i.checked;
    });
    return input?.value || '';
  }
}
